import { roundRect, circleObject } from "../../../../utils/utils";
import { FabricRectangular } from "../../../../views/grid/components/FabricRectangular";
import { DIAGRAM_EMIT_EVENTS } from "../../../../diagram/modules/DiagramEvents";
import { DiagramEventEmitter } from "../../../../diagram/modules/DiagramEventEmitter";
import {
    HEADER_OPEN_MENU_STYLE, SELECTED_HEADER_MENU_STYLE, HEADER_MENU_STYLE, HEADER_MENU_OPTIONS, HEADER_EDIT_BUTTON
} from "./config/headerMenu.config";
import {
    INVALID_CLASS_CONTAINER_STYLE, SELECTED_CLASS_CONTAINER_STYLE, DEFAULT_CLASS_CONTAINER_STYLE, SELECTED_CHILD_STROKE_COLOR
} from "./config/classContainer.config";
import { HEADER_CONFIG } from "./config/header.config";
import { DATA_MODEL_HEADER_LABEL_STYLE } from "./config/headerLabel.config";
import { ClassText } from "./ClassText";
import { DISABLED_ELEMENT_OVERLAY_COLOR } from "../../../../views/grid/const/disabled-elements.const";
import { getInstanceIDFromCanvasInstance } from "../../../../diagram/diagram-assets/diagram-positioning-state";

export class ClassHeader extends FabricRectangular {
    menuInstance;

    labelInstance;

    layout = {};

    state = {};

    labelStyle = DATA_MODEL_HEADER_LABEL_STYLE;

    headerMenuStyle = HEADER_MENU_STYLE;

    headerOpenedMenuStyle = HEADER_OPEN_MENU_STYLE;

    headerEditButton = HEADER_EDIT_BUTTON;

    parentUuid;

    circleDiameter;

    menuCircleX;

    menuCircleY;

    menuOptions = HEADER_MENU_OPTIONS;

    optionSelected;

    eventEmitter;

    menuIsOpen = false;

    menuCirclePos = {};

    data = { label: "Untitled group" };

    constructor(layout, state, ctx, data) {
        super(layout);
        this.ctx = ctx;
        this.layout = layout;
        this.state = state;
        this.parentUuid = data.uuid;
        if (data) this.data = { ...this.data, ...data };
        this.instanceId = getInstanceIDFromCanvasInstance(ctx);
        this.eventEmitter = new DiagramEventEmitter(this.instanceId);
        const labelStyle = { ...DATA_MODEL_HEADER_LABEL_STYLE, fontWeight: (this.state.selected ? 400 : 600) };
        this.labelInstance = new ClassText(layout, state, labelStyle, ctx, this.data.label);
    }

    draw() {
        const lineWidth = 1;

        this.ctx.clearRect(this.layout.x + lineWidth, this.layout.y - lineWidth, this.layout.width + lineWidth * 1, this.layout.height + lineWidth * 1);
        this.drawHeaderDividingLine();
        if (!this.preview) {
            this.headerMenuStyle = this.state.selected || this.state.active ? SELECTED_HEADER_MENU_STYLE : HEADER_MENU_STYLE;
            if (!this.state.readonly) {
                this.drawMenuPoint();
                this.drawEditButton();
            }
            this.drawHeaderName();
        }
    }

    setEventEmitter(ev) {
        // this.eventEmitter = ev;
    }

    drawHeaderDividingLine() {
        let style = this.state.dragHover ? INVALID_CLASS_CONTAINER_STYLE : this.state.selected ? SELECTED_CLASS_CONTAINER_STYLE : DEFAULT_CLASS_CONTAINER_STYLE;
        style = { ...style };
        if (this.state.childSelected) style.strokeStyle = SELECTED_CHILD_STROKE_COLOR;
        roundRect(this.layout.x + 3, this.layout.y + 2, this.layout.width - 3, this.layout.height - 2, HEADER_CONFIG.radius, style, this.ctx);
        if (this.state.disabled) {
            const disabledStyle = { fillStyle: DISABLED_ELEMENT_OVERLAY_COLOR };
            roundRect(this.layout.x, this.layout.y, this.layout.width, this.layout.height, HEADER_CONFIG.radius, disabledStyle, this.ctx);
        }
    }

    drawMenuPoint() {
        this.circleDiameter = this.layout.height * 2 / 3;
        const styles = { fillStyle: this.headerMenuStyle.fillStyleMenu };
        const radius = this.circleDiameter / 2; let circleX; let
            circleY;

        // this.menuCircleX = this.layout.x + this.layout.width - radius - this.headerMenuStyle.paddingRight;
        // this.menuCircleY = this.layout.y + this.layout.height / 2;
        // circleX = this.menuCircleX;
        // circleY = this.menuCircleY;

        // circleObject(this.menuCircleX, this.menuCircleY, radius, styles, this.ctx);
        // this.menuCirclePos = { circleX, circleY, radius };
        // this.drawMenuBullets(this.menuCircleX, this.menuCircleY);
    }

    drawEditButton() {
        const styles = { fillStyle: this.headerMenuStyle.fillStyleMenu };
        const radius = this.circleDiameter / 2; const { editWidth } = this.headerEditButton;
        const editHeight = this.layout.height * 2 / 3;
        const editX = this.layout.x + this.layout.width - this.circleDiameter - this.headerMenuStyle.paddingRight - editWidth;
        const editY = this.layout.y + radius / 2;

        roundRect(editX, editY, editWidth, editHeight, radius, styles, this.ctx);
        this.ctx.textAlign = this.headerEditButton.textAlign;
        this.ctx.fillStyle = this.state.selected ? "#ffffff" : "#256BDE";// this.headerEditButton.fillStyle;
        // style.selectedText = style.deselectedText = "#";

        this.ctx.fillText(this.headerEditButton.textValue, editX + editWidth / 2, editY + editHeight / 2);
    }

    isMovePoint(currentPoint) {
        const points = {
            A: { x: this.layout.x, y: this.layout.y },
            B: { x: this.layout.x + this.layout.width, y: this.layout.y },
            C: { x: this.layout.x + this.layout.width, y: this.layout.y + this.layout.height },
            D: { x: this.layout.x, y: this.layout.y + this.layout.height }
        }; let
            widthToExclude;

        widthToExclude = this.circleDiameter + this.headerEditButton.editWidth + (this.headerMenuStyle.paddingRight * 2);
        points.B.x -= widthToExclude;
        points.C.x -= widthToExclude;
        return this.pointInRect(currentPoint, points);
    }

    drawHeaderName() {
        const labelStyle = { ...DATA_MODEL_HEADER_LABEL_STYLE, fontWeight: (this.state.selected ? 400 : 600) };
        this.labelInstance.update(this.state, this.layout, labelStyle, this.data.label);
        this.labelInstance.draw();
    }

    drawHeaderMenu(payload, plugins) {
        const inputPosX = this.menuCircleX - payload.fabricCtx.diagramCamera.scrollbars.left
            + (payload.event.clientX - payload.event.layerX);
        const inputPosY = this.menuCircleY - payload.fabricCtx.diagramCamera.scrollbars.top
                + (payload.event.clientY - payload.event.layerY);

        const divElem = document.createElement("select");
        divElem.id = "menuHeaderId";
        divElem.style.background = this.headerMenuStyle.background;
        divElem.style.height = "auto";
        divElem.style.width = "auto";
        divElem.style.left = `${inputPosX}px`;
        divElem.style.top = `${inputPosY}px`;
        divElem.style.cursor = "pointer";
        divElem.style.position = "absolute";
        divElem.style.padding = "5px 0 10px 0";
        divElem.size = this.menuOptions.length;
        divElem.style["box-shadow"] = `0 0 0 1px${this.headerOpenedMenuStyle.boxShadow}`;

        for (let i = 0; i < this.menuOptions.length; i++) {
            const childElem = document.createElement("option");
            childElem.value = this.menuOptions[i].id;
            childElem.text = this.menuOptions[i].value;
            childElem.style["font-size"] = `${this.headerOpenedMenuStyle.fontSize}px`;
            childElem.style.padding = "5px 5px 0 5px";
            divElem.add(childElem);
            childElem.addEventListener("mouseover", this.mouseOverOption.bind(this));
            childElem.addEventListener("mouseleave", this.mouseOutOption.bind(this));
        }
        divElem.addEventListener("change", this.selectOptionMenu.bind(this, plugins));
        divElem.addEventListener("blur", this.menuLoseFocus.bind(this));
        document.body.appendChild(divElem);
        setTimeout(() => {
            divElem.focus();
        }, 0);
        this.menuIsOpen = true;
    }

    closeImportExportMenu() {
        const element = document.getElementById("menuHeaderId");
        this.menuIsOpen = false;
        if (element) {
            element.remove();
        }
    }

    mouseOverOption(event) {
        event.target.style.backgroundColor = this.headerOpenedMenuStyle.backgroundSelectedoption;
    }

    mouseOutOption(event) {
        event.target.style.backgroundColor = "transparent";
    }

    selectOptionMenu(plugins, event) {
        const { pluginId } = plugins.get(this.parentUuid);
        this.eventEmitter.emitEvent(DIAGRAM_EMIT_EVENTS.DATA_MODEL_MENU_HEADER_ACTION,
            { DATA_MODEL_UUID: this.parentUuid, DATA_MODEL_ID: pluginId, SELECTED_OPTION: event.target.value });

        const element = document.getElementById("menuHeaderId");
        if (element) {
            this.optionSelected = true;
            element.remove();
        }
    }

    menuLoseFocus() {
        const element = document.getElementById("menuHeaderId");

        if (element && !this.optionSelected && this.menuIsOpen) {
            element.remove();
        } else {
            this.optionSelected = false;
        }
        this.menuIsOpen = false;
    }

    update(layout, state, data) {
        if (layout) {
            this.layout = { ...this.layout, ...layout };
            this.setPoints(layout);
        }
        if (data) {
            this.data = data;
            const { oldState } = this.data;
            this.eventEmitter.emitEvent(DIAGRAM_EMIT_EVENTS.CELL_INDEPENDENT_CONTAINER_UPDATED,
                { DATA_MODEL_UUID: this.data.uuid, DATA_MODEL_ID: this.data.id, DATA_MODEL_LABEL: this.data.label }, false, true);
            this.eventEmitter.emitEvent(DIAGRAM_EMIT_EVENTS.MULTIPLE_ACTIONS_HAPPENED, [
                { event: DIAGRAM_EMIT_EVENTS.CELL_INDEPENDENT_CONTAINER_UPDATED,
                    oldState,
                    payload: { DATA_MODEL_UUID: this.data.uuid, DATA_MODEL_ID: this.data.id, DATA_MODEL_LABEL: this.data.label } }
            ], true, false);
        }
        if (state) this.state = { ...this.state, ...state };
    }

    drawMenuBullets(x, y) {
        const radius = this.headerMenuStyle.radiusBullets;
        const styles = { fillStyle: this.headerMenuStyle.fillStyleBullets };
        const difBettwenBullet = radius * 2 + this.headerMenuStyle.spaceBullets;

        circleObject(x, y - difBettwenBullet, radius, styles, this.ctx); // top bullet

        circleObject(x, y, radius, styles, this.ctx); // middle bullet

        circleObject(x, y + difBettwenBullet, radius, styles, this.ctx); // bottom bullet
    }
}
